module.exports = __webpack_public_path__ + "img/LastBrand.a290ce5a.png";